import React from "react"

const AlertModal = ({ open, title, message, onClose, actions = [], primaryClass }) => {
  if (!open) return null

  const hasActions = Array.isArray(actions) && actions.length > 0
  const finalActions = hasActions
    ? actions
    : [
        {
          label: "OK",
          onClick: onClose,
          variant: "primary",
        },
      ]

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Dialog */}
      <div className="absolute inset-0 flex items-center justify-center p-6">
        <div className="relative w-full max-w-md rounded-[28px] bg-black/40 text-light-default shadow-2xl backdrop-blur-xl ring-1 ring-white/10">
          <div className="px-6 pt-6 pb-4 text-left">
            {title ? (
              <div className="text-[18px] font-semibold mb-1">
                {title}
              </div>
            ) : null}
            {message ? (
              <div className="text-[16px] text-white/80 leading-snug break-all">
                {message}
              </div>
            ) : null}
          </div>
          <div className={`px-4 pb-5 flex ${finalActions.length === 2 ? "flex-row gap-3" : "flex-col gap-2"}`}>
            {finalActions.map((action, idx) => {
              const base = `${finalActions.length === 2 ? "flex-1" : "w-full"} h-12 rounded-full text-[16px] font-semibold transition-colors ring-1 ring-white/10 bg-white/10` 
              const variant =
                action?.variant === "destructive"
                  ? "text-danger-default hover:bg-white/12 active:bg-white/15"
                  : action?.variant === "primary"
                  ? (primaryClass || "text-light-default hover:bg-white/12 active:bg-white/15")
                  : "text-light-default/80 hover:bg-white/12 active:bg-white/15"
              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => {
                    action?.onClick?.()
                    if (!action?.preventClose) onClose?.()
                  }}
                  className={`${base} ${variant}`}
                >
                  {action.label}
                </button>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlertModal


